import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Form } from 'informed';
import PropTypes from 'prop-types';
import queryString from 'query-string';

const EnviarAplicacaoModal = ({  isOpen, toggle, idCollection }) => {

    return (
        <Form>
            <Modal isOpen={isOpen} toggle={toggle} size='md' centered>
                <ModalHeader toggle={toggle}>
                    Adicionar Estudante
                </ModalHeader>
                <ModalBody style={{borderRadius:'4px 4px', paddingBottom:'30px'}}>
                    <div className="card-header justify-content-start">
                        <p style={{fontSize: "16px"}}>
                            Deseja vincular Estudantes a essa atividade?
                        </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-end mr-4">
                        <button type="button" className="btn-modal-secundary" onClick={toggle}>
                            Agora não
                        </button>
                        <button
                            type="submit"
                            className="btn-modal-primary"
                            onClick={()=>{
                                const urlEducat = window.location.origin;
                                let destino
                                switch(urlEducat){
                                    case(`http://localhost:3000`):
                                        destino = `http://localhost:3001`;
                                        break;

                                    case(`https://educat-sesi.didatti.net.br`):
                                        destino = `https://exams-sesi-2022.didatti.net.br`;
                                        break;

                                    case(`https://educat-sesi-avaliacao.didatti.net.br`):
                                        destino = `https://exams-sesi-avaliacao-2022.didatti.net.br`;
                                        break;

                                    case(`https://educat-dev-2022.didatti.net.br`):
                                        destino = `https://exams-dev-2022.didatti.net.br`;
                                        break;
                                }
                                const exportLink = `/exams/dashboard-open/list?collection=${idCollection}`;

                                const pathName = `/external-application-middleware?${queryString.stringify(
                                    { applicationName: 'exams', path: exportLink, forceLogout: false }
                                  )}`;

                                window.open(pathName, '_self');
                            }}
                        >
                            Sim
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </Form>
    )
}

export default EnviarAplicacaoModal;

EnviarAplicacaoModal.propTypes = {
    toggle: PropTypes.func,
    isOpen: PropTypes.bool,
}
